<app-example-format
  [codeHtmlPath]="'code/examples/example-draw/example-draw-edit-basic/example-draw-edit-basic.component.html'"
  [codeScssPath]="'code/examples/example-draw/example-draw-edit-basic/example-draw-edit-basic.component.scss'"
  [codeTypescriptPath]="'code/examples/example-draw/example-draw-edit-basic/example-draw-edit-basic.component.ts'"
  [title]="componentInfo.title"
  urlChangelog=""
  urlCodeHtml="example-draw/example-draw-edit-basic/example-draw-edit-basic.component.html"
  urlCodeScss="example-draw/example-draw-edit-basic/example-draw-edit-basic.component.scss"
  urlCodeTypescript="example-draw/example-draw-edit-basic/example-draw-edit-basic.component.ts"
  urlGitHub=""
  urlKaartConfig="example-draw-options/kaartconfig.json"
  urlTSDocs=""
  urlTreeConfig=""
  urlVoorbeelden=""
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>{{ componentInfo.introduction }}</p>
    <p>
      In onderstaande voorbeeld kan een aantal bestaande tekeningen worden
      verplaatst of bewerkt. Bij bewerk tekening kunnen bestanade punten
      verplaatst, of nieuwe punten toegevoegd worden.
    </p>
  </div>

  <div page-functionality>
    <div class="row">
      <!-- DOCS:START functionality -->
      <div class="col-md-9 col-sm-10">
        <div class="map-container">
          <ggc-map
            [webServices]="mapConfig"
            (events)="onMapEvent($event)"
          ></ggc-map>
        </div>
      </div>
      <!-- DOCS:END functionality -->

      <div class="col-md-2 col-sm-2">
        <div class="d-flex flex-column align-items-stretch">
          <button
            [class.active]="activeEditType() === editType.MOVE"
            (click)="startMove()"
          >
            Verplaats tekening
          </button>
          <button
            [class.active]="activeEditType() === editType.MODIFY"
            (click)="startModify()"
          >
            Bewerk tekening
          </button>
        </div>
      </div>
    </div>
  </div>
</app-example-format>
